import axios from 'axios';

export default class AWS {
  static deleteFileFromS3 = (data, successCallback, failureCallback) => {
    axios
      .post('/deleteFileFromS3', {
        filename: data.filename,
        bucketname: data.bucketname,
      })
      .then(function(result) {
        successCallback(result);
      })
      .catch(function(err) {
        failureCallback(err);
      });
  };

  static uploadToS3 = (
    file,
    filename,
    bucketname,
    successCallback,
    failureCallback,
  ) => {
    let bucket = bucketname ? bucketname : 'guest_pictures_bucket';

    axios
      .post('/upload', {
        filename: filename,
        filetype: file.type,
        bucketname: bucket,
        file: file,
      })
      .then(function(result) {
        var signedUrl = result.data;

        var options = {
          headers: {
            'Content-Type': file.type,
          },
        };

        return axios.put(signedUrl, file, options);
      })
      .then(function(result) {
        successCallback(result.config.url, filename);
      })
      .catch(function(err) {
        console.log("catched err = ", err);
        failureCallback(err);
      });
  };
}
